import { Component } from "react-image-crop";
import Table from "../../components/table/Table";
import DropdownAction from "../../components/dropdown/DropdownAction";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import SwalServices from "../../services/swalServices/SwalServices";
import moment from "moment";
import { saveAs } from "file-saver";
import ButtonLoader from "../../components/common/buttonLoader/ButtonLoader";
import { getAuditContext } from "../../utils/AuthenticationLibrary";


export default class ViewWaitingList extends Component {
  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices()
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
        // selectedEvent: [],
      },
      actionDropdown: ["Notify"],
      totalResultes: "",
      bookingWaitingList: [],
      bookingWaiting: [],
      isLoading: false,
      isLoadingExport: false,
    }
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getAllBookingWaitingList(newPagination)
    });
  };

  getAllBookingWaitingList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.BookingServices.getAllBookingWaitingList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.eventDate = key.eventDate
            ? moment(key.eventDate).format("DD MMM YYYY")
            : "-";
          return key;
        });
        this.setState({ bookingWaitingList: details }, () => {

        });
        this.setState({
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };


  getBookingWaitingDetailsById = (bookingWaitingListId) => {
    const Audit = getAuditContext()
    const createdAppId = Audit.appId
    const createdBy = Audit.adminUserId
    const request = [bookingWaitingListId,createdAppId,createdBy];
    this.setState({ isLoading: true });

    this.BookingServices.getBookingWaitingDetailsById(request).then((response) => {
      this.setState({ isLoading: false });

      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.message === null) {
          this.swalServices.Success("Notification email sent.");
          this.getAllBookingWaitingList();
        }
        this.setState({
          waitingDetails: response.responseItem.responseContent,
        });

        // Optional: window.location.reload();
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };


  actionClick = (index, value, option, event) => {
    if (option === "Notify") {

      if (value && value > 0) {
        let details = this.state.bookingWaitingList;
        let bookingWaiting = details.find((x) => x.bookingWaitingListId === value)
        if (bookingWaiting) {
          this.getBookingWaitingDetailsById(bookingWaiting.bookingWaitingListId);
        }
      }
    }
  };

  actions = (element, index, value) => {
    return element !== "EventId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdown}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };

  searchByName = (value) => {
    const updatedPagination = {
      ...this.state.pagination,
      searchText: value,
    };

    if (value.length > 2) {
      updatedPagination.pageNo = 1;
      updatedPagination.pageSize = 10;
    }
    this.setState(
      {
        pagination: updatedPagination,
      },
      this.getAllBookingWaitingList
    );
  }

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getAllBookingWaitingList();
      } else if (fulldate === null) {
        this.getAllBookingWaitingList();
      }
    });
  }

  exportAllViewWaitingMembers = () => {
    let request = { ...this.state.pagination };
    request.pageSize = 100000;
    this.setState({ isLoadingExport: true })
    this.BookingServices.exportAllViewWaitingMembers(request)
      .then((response) => {
        if (response.status === 200 && response.data != null) {
          let blob = new Blob([response.data]);
          if (blob.size > 300) {
            saveAs(blob, `WaitingReport.xlsx`);
          } else {
            this.swalServices.Error("No Records Found!");
          }
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({
          isLoading: false,
          isLoadingExport: false
        });

      });
  };

  clearFilters = () => {
    const newPagination = {
      pageNo: 1,
      pageSize: 10,
      orderByColumn: "",
      orderFlag: 0,
      searchText: "",
      status: 0,
      dateFrom: "",
      dateTo: "",
    };

    this.setState({ pagination: newPagination }, () => {
      this.getAllBookingWaitingList(this.state.pagination);
    });
  };

  componentDidMount() {
    this.getAllBookingWaitingList();
  }

  render() {
    return (
      <div className="main-body-section View-booking-sec">
        <div className="top-filter-sec">
          <div className="grid grid-cols-12 gap-6">
            <div className="2xl:col-span-6 lg:col-span-6 col-span-12">
              <div className="grid grid-cols-12 gap-6 items-center w-full">
                <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                  <input
                    id="default"
                    name="dateFrom"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateFrom}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                <div className=" 2xl:col-span-2 lg:col-span-2 col-span-12 w-full text-center">
                  <h2 className="text-xl theme-color">To</h2>
                </div>
                <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                  <input
                    id="default"
                    name="dateTo"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateTo}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>
            <div className="2xl:col-span-4 lg:col-span-6 col-span-12 items-left">
              <div className="right-search flex items-center justify-start">
                <div className="text-[#757575] text-xl pr-3">Search by Event Name/Requestor Email</div>
                <input
                  id="default"
                  className="col-span-2 text-lg font-bold h-[55px] w-full text-[#757575] border-white"
                  type="text"
                  value={this.state.pagination.searchText}
                  onChange={(e) => this.searchByName(e.target.value)}
                />
              </div>
            </div>
            <div className="xl:col-span-2 lg:col-span-2 col-span-12">
              <div className="flex flex-col items-end justify-end h-full pb-1 space-y-2">
                <button
                  className="btn btn-red text-white mb-6"
                  onClick={() => this.clearFilters()}
                >
                  <span className="text-xl text-white font-semibold tracking-normal">
                    Clear
                  </span>
                </button>
                {
                  this.state.isLoadingExport ?
                    <ButtonLoader />
                    :
                    <button
                      className="btn btn-red text-white"
                      onClick={() => this.exportAllViewWaitingMembers()}
                    >
                      <span className="text-xl text-white font-semibold tracking-normal">
                        Export
                      </span>
                    </button>
                }
              </div>
            </div>


            {/* <div className="xl:col-span-2 lg:col-span-2 col-span-12">
              <div className="flex items-end justify-end h-full pb-1">
                <button
                  className="btn btn-red text-white"
                  onClick={() => this.exportAllViewWaitingMembers()}
                >
                  <span className="text-xl text-white font-semibold tracking-normal">
                    Export
                  </span>
                </button>
              </div>
            </div> */}
          </div>

        </div>
        <div className="bottom-result-table">
          {/* Table Section Start */}
          <div className="mt-8 credit-note-approval-table">
            <Table
              columns={[
                { name: "EventName", title: "Event Name" },
                { name: "EventDate", title: "Event Date" },
                { name: "seatAvailablity", title: "Seat Availability" },
                { name: "requestorName", title: "Requestor Name" },
                { name: "RequestorContactNumber", title: "Requestor Contact Number" },
                { name: "requestorEmailAddress", title: "Requestor Email Address" },
                { name: "isNotified", title: "Status" },
                { name: "EventId", title: "Actions" },

              ]}
              rows={this.state.bookingWaitingList}
              isLoading={this.state.isLoading}
              pagination={this.state.pagination}
              totalResultes={this.state.totalResultes}
              totalCount={this.state.totalResultes}
              sortingColumns={[""]}
              setPagination={this.setPagination.bind(this)}
              customScope={[
                {
                  column: "EventId",
                  renderTableData: this.actions.bind(this),
                },
              ]}
            />
          </div>
          {/*Table Section End */}
        </div>
      </div>
    )
  }
}